export const hoverTooltipWithoutDuplication = "TGc87";
export default {hoverTooltipWithoutDuplication};